// This is a port of dart's Util.getColor function

const colors = [
  '#ff6767',
  '#66e0da',
  '#f5a2d9',
  '#f0c722',
  '#6a85e5',
  '#fd9a6f',
  '#92db6e',
  '#73b8e5',
  '#fd7590',
  '#c78ae5',
]

export function getColor(id: string) {
  // This is a very basic hash function, I don't think we need
  // anything more complex for this use case
  const hashCode = id.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 4) - acc)
  }, 0)

  return colors[Math.abs(hashCode) % colors.length]
}
